module.exports = __webpack_public_path__ + "assets/img/B2.57614007.jpg";